// extracted by mini-css-extract-plugin
export default {"container":"confirmChangesModal_container__TcAxx"};